import { z } from 'zod';

export const schema = z.object({
  cancellationExplanationCode: z.string(),
});

export type FormValues = z.infer<typeof schema>;
